// MSAL is loaded on demand (only when someone clicks "Sign in with
// Microsoft") so it stays out of the main bundle and can never break app
// start-up.
const loadMsal = () => import("@azure/msal-browser");

// Blank page in /public - register `${origin}/azure-redirect.html` as a
// "Single-page application" redirect URI on the Azure app registration.
const AZURE_REDIRECT_PATH = "/azure-redirect.html";

let msalInstance = null;
let msalInstanceKey = "";

const getMsalInstance = async (clientId, authority) => {
  const instanceKey = `${clientId}|${authority}`;
  if (msalInstance && msalInstanceKey === instanceKey) return msalInstance;

  const { PublicClientApplication } = await loadMsal();
  msalInstance = new PublicClientApplication({
    auth: {
      clientId,
      authority,
      redirectUri: `${window.location.origin}${AZURE_REDIRECT_PATH}`,
    },
    // WeekMate keeps its own session - MSAL's cache only needs to survive
    // the popup round-trip.
    cache: { cacheLocation: "sessionStorage" },
  });
  msalInstanceKey = instanceKey;
  await msalInstance.initialize();
  return msalInstance;
};

/**
 * Open the Microsoft sign-in popup and resolve with the ID token, or `null`
 * if the user closed/cancelled the popup.
 */
export const signInWithMicrosoft = async ({ clientId, authority }) => {
  const instance = await getMsalInstance(clientId, authority);
  try {
    const result = await instance.loginPopup({
      scopes: ["openid", "profile", "email"],
      prompt: "select_account",
    });
    return result?.idToken || null;
  } catch (error) {
    const { BrowserAuthErrorCodes } = await loadMsal();
    if (error?.errorCode === BrowserAuthErrorCodes.userCancelled) return null;
    throw error;
  }
};
